export function BrandLogo(props: { readonly compact?: boolean; readonly light?: boolean }) {
  return (
    <span
      className={`brand-logo${props.compact ? ' brand-logo-compact' : ''}${props.light ? ' brand-logo-light' : ''}`}
      aria-label="قالیشور — Ghalishor"
    >
      <span className="brand-logo-fa">قالیشور</span>
      <span className="brand-logo-en" lang="en" dir="ltr">GHALISHOR</span>
    </span>
  );
}

export function BrandWelcome() {
  return (
    <span className="brand-welcome">
      <span>به</span>
      <BrandLogo />
      <span>خوش آمدید</span>
    </span>
  );
}
